import { KnBrCommonService } from './../services/kn-br-common.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AuthService, GlobalMessageService, WindowRef, GlobalMessageType, TranslatePipe } from '@spartacus/core';
import { LoginFormComponent, LoginFormComponentService } from '@spartacus/user/account/components';
import { FormErrorsComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { Auth0Service } from '../services/knbr-new-auth0.service';
import { take } from 'rxjs';
@Component({
  selector: 'kn-br-login-form',
  templateUrl: './kn-br-login-form.component.html',
  styleUrls: ['./kn-br-login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormErrorsComponent, AsyncPipe, TranslatePipe],
})
export class KnBrLoginFormComponent extends LoginFormComponent implements OnInit {
  errorMessage: string = 'Bad credentials. Please login again';
  loginInProgress = false;
  shouldShowLoginScreen = false;
  constructor(
    protected auth: AuthService,
    protected globalMessageService: GlobalMessageService,
    protected fb: FormBuilder,
    protected winRef: WindowRef,
    protected loginFormComponentService: LoginFormComponentService,
    protected knBrCommonService: KnBrCommonService,
    protected newAuthService: Auth0Service,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(loginFormComponentService);
  }
  ngOnInit(): void {
    // super.ngOnInit();
    this.knBrCommonService
      .getAuth0EnabledStatus()
      .pipe(take(1))
      .subscribe((responseData: any) => {
        const flagValue = responseData[0];
        this.redirectToAuth0PortalBasedOnTheFlag(flagValue);
      });
    if (this.winRef) {
      this.winRef.document.querySelector('kn-br-login-form').classList.add('knbr-user-form');
    }
  }

  redirectToAuth0PortalBasedOnTheFlag(auth0FlagValue) {
    if (auth0FlagValue === 'true') {
      this.redirectToNewAuth0SSO();
    } else {
      this.shouldShowLoginScreen = true;
      this.changeDetectorRef.detectChanges();
      //will do nothing as sales portal regular SSO is not auto redirect
      // user will select exclusively on our application login screen to where they want to go
    }
  }

  checkIsValidUser() {
    if (this.form.valid) {
      this.loginInProgress = true;

      const { userId, password } = this.form.controls;
      this.knBrCommonService.checkIsValidUser(userId.value).subscribe(
        (response: any) => {
          if (response?.response === 'Authorized') {
            this.loginFormComponentService.login();
          } else {
            this.globalMessageService.add(response, GlobalMessageType.MSG_TYPE_ERROR);
          }
          this.loginInProgress = false;
          this.changeDetectorRef.detectChanges();
        },
        (error) => {
          const errorResponse = error.error;
          if (errorResponse && errorResponse.errors && errorResponse.errors.length > 0) {
            this.globalMessageService.add(this.errorMessage, GlobalMessageType.MSG_TYPE_ERROR);
          }
          this.loginInProgress = false;
          this.changeDetectorRef.detectChanges();
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  redirectToSSO(value) {
    if (value === 'internal') {
      window.open(environment.internalSSO, '_self');
    } else {
      window.open(environment.externalSSO, '_self');
    }
  }

  async redirectToNewAuth0SSO() {
    const newUrl = await this.newAuthService.getAuthorizeUrl();
    window.open(newUrl, '_self');
  }
}
